var map = {
	"./de.json": [
		84954,
		954
	],
	"./en.json": [
		96082,
		82
	],
	"./es.json": [
		65022,
		641
	],
	"./fr.json": [
		54521,
		521
	],
	"./it.json": [
		16852,
		852
	],
	"./pt.json": [
		72969,
		969
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 25852;
module.exports = webpackAsyncContext;